<template>
  <div>
    <div v-if="$route.params.folder === 'settings'">
      <settings />
    </div>
    <div v-else>
      <msgs-table
        ref="msgtable"
        @play-msg="play($event)"
        @text-open="readAsText($event)"
        @xfer-msg="xferMsg($event)"
        @del-msg="delMsg($event)"
        @move-to-custom-folder="moveToCustomFolder($event)"
        @remove-from-custom-folder="removeFromCustomFolder($event)"
        @bulk-mark-read="bulkMarkRead($event)"
        @bulk-mark-unread="bulkMarkUnread($event)"
        @bulk-xfer-msg="bulkXferMsg($event)"
        @bulk-favorite="bulkMarkAsFavorite($event)"
        @bulk-unfavorite="bulkUnmarkAsFavorite($event)"
        @bulk-del-msg="bulkDelMsg($event)"
        @bulk-move-to-custom-folder="bulkMoveToCustomFolder($event)"
        @bulk-remove-from-custom-folder="bulkRemoveFromCustomFolder($event)" />
    </div>
    <msg-xfer :show="xferMsgShow" :msg="xferMsgItem" @xfer-dest="xferMsgConfirm"
      @cancel="xferMsgItem=null; xferMsgShow=false" />
    <msg-del :show="delMsgShow" :msg="delMsgItem" @delete-confirm="delMsgConfirm"
      @delete-cancel="delMsgItem=null; delMsgShow=false" />
    <msg-xfer :show="bulkXferMsgShow" :bulk="bulkXferMsgItems" @xfer-dest="bulkXferMsgConfirm"
      @cancel="bulkXferMsgItems=[]; bulkXferMsgShow=false" />
    <msg-del :show="bulkDelMsgShow" :bulk="bulkDelMsgItems" @delete-confirm="bulkDelMsgConfirm"
      @delete-cancel="bulkDelMsgItems=[]; bulkDelMsgShow=false" />
    <move-to-custom-folder :show="moveToCustomFolderShow" :msg="moveToCustomFolderItem"
      @close="moveToCustomFolderItem = null;moveToCustomFolderShow=false" />
    <move-to-custom-folder :show="bulkMoveToCustomFolderShow" :bulk="bulkMoveToCustomFolderItems"
      @close="bulkMoveToCustomFolderItems=null;bulkMoveToCustomFolderShow=false" />
    <contact-form />
    <contact-details-dialog />
    <contact-delete-dialog />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Settings from '@/components/voicemails/settings/index'
import MsgsTable from '@/components/voicemails/msgs_table/index'
import MsgXfer from '@/components/voicemails/msg_xfer'
import MsgDel from '@/components/voicemails/msg_del'
import MoveToCustomFolder from '@/components/voicemails/move_to_custom_folder'
import ContactForm from '@/components/contacts/forms/contact_dialog'
import ContactDetailsDialog from '@/components/contacts/details_dialog'
import ContactDeleteDialog from '@/components/contacts/forms/delete_contact'

export default {
  name: 'voicemails-panel',
  data () {
    return {
      moveToCustomFolderShow: false,
      moveToCustomFolderItem: null,
      bulkMoveToCustomFolderShow: false,
      bulkMoveToCustomFolderItems: [],
      xferMsgShow: false,
      xferMsgItem: null,
      delMsgShow: false,
      delMsgItem: null,
      bulkXferMsgShow: false,
      bulkXferMsgItems: [],
      bulkDelMsgShow: false,
      bulkDelMsgItems: []
    }
  },
  components: {
    MsgXfer,
    MsgDel,
    MsgsTable,
    ContactForm,
    ContactDetailsDialog,
    ContactDeleteDialog,
    Settings,
    MoveToCustomFolder
  },
  computed: {
    ...mapGetters({
      voicemails: 'voicemails',
      boxOwner: 'voicemails/owner',
      pagination: 'voicemails/pagination'
    }),
    vmNew () {
      return this.voicemails.filter(vm => !vm.isRead)
    },
    vmRead () {
      return this.voicemails.filter(vm => vm.isRead)
    }
  },
  methods: {
    ...mapActions({
      setPage: 'voicemails/setPage',
      reloadPage: 'voicemails/reloadPage',
      toggleRead: 'voicemails/toggleRead',
      setAsRead: 'voicemails/setAsRead',
      transferMsg: 'voicemails/transferMsg',
      deleteMsg: 'voicemails/deleteMsg',
      bulkMarkAsRead: 'voicemails/bulkMarkAsRead',
      bulkMarkAsUnread: 'voicemails/bulkMarkAsUnread',
      bulkTransferMsg: 'voicemails/bulkTransferMsg',
      bulkDeleteMsg: 'voicemails/bulkDeleteMsg',
      bulkFavorite: 'voicemails/bulkFavorite',
      bulkUnfavorite: 'voicemails/bulkUnfavorite',
      moveOutOfCustomFolder: 'voicemails/removeFromCustomFolder',
      bulkMoveOutCustomFolder: 'voicemails/bulkRemoveFromCustomFolder'
    }),

    goToPage (page) {
      this.$refs.msgtable.goToPage(page)
    },

    async onItemDelete () {
      if (this.pagination.curPage > this.pagination.pages) {
        this.setPage(this.pagination.pages)
        await this.reloadPage()
        this.goToPage(this.pagination.pages)
      }
    },

    xferMsg (msg) {
      this.xferMsgItem = msg
      this.xferMsgShow = true
    },

    async xferMsgConfirm (dest) {
      await this.transferMsg({ id: this.xferMsgItem.id, dest })
      this.xferMsgItem = null
      this.xferMsgShow = false
      await this.onItemDelete()
    },

    delMsg (msg) {
      this.delMsgItem = msg
      this.delMsgShow = true
    },

    async delMsgConfirm () {
      await this.deleteMsg(this.delMsgItem.id)
      this.delMsgItem = null
      this.delMsgShow = false
      await this.onItemDelete()
    },

    moveToCustomFolder (voicemail) {
      this.moveToCustomFolderItem = voicemail
      this.moveToCustomFolderShow = true
    },

    removeFromCustomFolder (voicemail) {
      const id = voicemail.id
      this.moveOutOfCustomFolder({ id })
    },

    bulkMoveToCustomFolder (voicemails) {
      this.bulkMoveToCustomFolderItems = voicemails
      this.bulkMoveToCustomFolderShow = true
    },

    bulkRemoveFromCustomFolder (voicemails) {
      const ids = voicemails.map(msg => msg.id)
      this.bulkMoveOutCustomFolder({ ids })
    },

    async bulkMarkRead (items) {
      await this.bulkMarkAsRead(items.map(msg => msg.id))
    },

    async bulkMarkUnread (items) {
      await this.bulkMarkAsUnread(items.map(msg => msg.id))
    },

    async bulkMarkAsFavorite (items) {
      await this.bulkFavorite(items.map(msg => msg.id))
    },

    async bulkUnmarkAsFavorite (items) {
      await this.bulkUnfavorite(items.map(msg => msg.id))
    },

    bulkXferMsg (items) {
      this.bulkXferMsgItems = items
      this.bulkXferMsgShow = true
    },

    async bulkXferMsgConfirm (dest) {
      await this.bulkTransferMsg({ ids: this.bulkXferMsgItems.map(msg => msg.id), dest })
      this.bulkXferMsgItems = []
      this.bulkXferMsgShow = false
      await this.onItemDelete()
    },

    bulkDelMsg (items) {
      this.bulkDelMsgItems = items
      this.bulkDelMsgShow = true
    },

    async bulkDelMsgConfirm () {
      await this.bulkDeleteMsg(this.bulkDelMsgItems.map(msg => msg.id))
      this.bulkDelMsgItems = []
      this.bulkDelMsgShow = false
      await this.onItemDelete()
    }
  }
}
</script>

<style scoped>
</style>
